// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1XTEI","col":"styles_col__2shQD"};